import { render, staticRenderFns } from "./quanziRanking.vue?vue&type=template&id=e095b88c&scoped=true&"
import script from "./quanziRanking.vue?vue&type=script&lang=ts&"
export * from "./quanziRanking.vue?vue&type=script&lang=ts&"
import style0 from "./quanziRanking.vue?vue&type=style&index=0&id=e095b88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e095b88c",
  null
  
)

export default component.exports